// Footer.jsx
import { Text, View } from "@react-pdf/renderer";
import AnnualGuideStyles from "./styles/dccReportStyles";

const Footer = ({ primaryColor, regulatoryText }) => {
  const styles = AnnualGuideStyles(primaryColor || "081e56");
  return (
    <View style={styles.footer} fixed>
      <Text style={styles.pageFooterText}>{regulatoryText}</Text>
    </View>
  );
};

export default Footer;
